import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';

export const updateNewUserKey = 'updateNewUser';

export interface UpdateNewUserState {
  updateNewUserResponse: any;
  updateNewUserFailure: any;
  loaded: boolean;
}

export const initialState: UpdateNewUserState = {
  updateNewUserResponse: undefined,
  updateNewUserFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.updateNewUserSuccess, (state, action) => ({
    ...state,
    updateNewUserResponse: action.response,
    loaded: true
  })),

  on(actions.updateNewUserFailure, (state, action) => ({
    ...state,
    updateNewUserFailure: action.error
  }))
);

export const updateNewUser = (state: UpdateNewUserState) => state.updateNewUserResponse;
